export default [{
  path: '/dangManage',
  name: '产品管理',
  component: resolve => require(['@/views/home'], resolve),
  children: [
    {
      path: 'index',
      name: '档案管理0',
      meta: {
        title: '档案管理0'
      },
      component: resolve => require(['@/views/configuration/dangManage'], resolve),
    },
    {
      path: 'ni',
      name: '档案管理1',
      meta: {
        title: '档案管理1'
      },
      component: resolve => require(['@/views/configuration/ni'], resolve),
    },
    {
      path: 'customAttr',
      name: '档案管理2',
      meta: {
        title: '档案管理2'
      },
      component: resolve => require(['@/views/configuration/customAttr'], resolve),
    },
  ]
},
]



// WEBPACK FOOTER //
// ./src/router/dangan_routers.js